var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.819 25.7089V28.0145C150.816 33.4187 148.943 38.6771 145.48 43.0055C142.017 47.334 137.15 50.5004 131.604 52.0327C126.058 53.565 120.13 53.381 114.705 51.5081C109.28 49.6353 104.648 46.1739 101.5 41.6403C98.3524 37.1067 96.8573 31.7437 97.2378 26.3513C97.6184 20.9588 99.8542 15.8257 103.612 11.7176C107.369 7.60943 112.448 4.74637 118.089 3.55538C123.73 2.36439 129.632 2.90929 134.915 5.1088",
    stroke: "#60A5FA",
    strokeWidth: 3.1656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.953 25.5085L123.999 33.0268L150.819 7.96582",
    stroke: "#60A5FA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCheck);
export default __webpack_public_path__ + "static/media/icon-circle-check.7932a23ae41d57a6fe85f227e19e1b58.svg";
export { ForwardRef as ReactComponent };